module.exports = __webpack_public_path__ + "img/ryzs13.3761e033.jpg";